var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState, } from 'react';
import { useEventComposerGlobalContext } from '../../composers/EventComposerGlobalContext';
import { useFeatureFlags } from '@robinpowered/dashboard-apps-common';
import { useFormContext, useWatch } from 'react-hook-form';
import { useWorkplaceServiceRequest, } from '../../hooks/useWorkplaceServiceRequest';
var SpaceDetailsContext = createContext({
    requestOnlySpace: undefined,
    initialEvent: undefined,
    eventPermissions: undefined,
    onTrackBufferEvent: undefined,
    showMeetingBuffers: false,
    loading: false,
    /* Workplace Service Request */
    workplaceServiceRequestFormStatus: undefined,
    setWorkplaceServiceRequestFormStatus: function () { },
    spaceForMeetingServiceData: undefined,
    spaceForMeetingServiceLoading: false,
    spaceForMeetingServiceError: undefined,
    refetchSpaceForMeetingService: function () { },
    handleGetSpaceForMeetingService: function () { },
    handleWorkplaceServiceError: function () { },
    onSuccessfulRequest: function () { },
});
export var SpaceDetailsProvider = function (_a) {
    var _b;
    var children = _a.children, eventPermissions = _a.eventPermissions, initialEvent = _a.initialEvent, spaceId = _a.spaceId;
    var _c = __read(useState(undefined), 2), workplaceServiceRequestFormStatus = _c[0], setWorkplaceServiceRequestFormStatus = _c[1];
    var _d = useEventComposerGlobalContext(), requestOnlySpace = _d.requestOnlySpace, onTrackBufferEvent = _d.onTrackBufferEvent, onError = _d.onError, requestFormId = _d.requestFormId, setSpaceRequestFormCompletion = _d.setSpaceRequestFormCompletion;
    var setValue = useFormContext().setValue;
    var _e = __read(useWatch({
        name: ['isAllDayEvent', 'recurrenceRule', 'uid'],
    }), 3), isAllDayEvent = _e[0], recurrenceRule = _e[1], eventUid = _e[2];
    var _f = useFeatureFlags(), checkFlag = _f.checkFlag, featureFlagsLoading = _f.loading;
    var _g = useWorkplaceServiceRequest({
        spaceId: spaceId,
        onError: onError,
        recurrenceId: (_b = initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.recurrenceId) !== null && _b !== void 0 ? _b : null,
        eventUid: eventUid,
        setWorkplaceServiceRequestFormStatus: setWorkplaceServiceRequestFormStatus,
    }), handleWorkplaceServiceError = _g.handleWorkplaceServiceError, onSuccessfulRequest = _g.onSuccessfulRequest, spaceForMeetingServiceData = _g.spaceForMeetingServiceData, spaceForMeetingServiceLoading = _g.spaceForMeetingServiceLoading, spaceForMeetingServiceError = _g.spaceForMeetingServiceError, refetchSpaceForMeetingService = _g.refetchSpaceForMeetingService, handleGetSpaceForMeetingService = _g.handleGetSpaceForMeetingService;
    // Feed the required-form completion into the global context (validation
    // reads it there — see useFooterValidation). Only settle to
    // complete/incomplete once the query has answered; while it hasn't, the
    // global value stays 'unknown' and validation does not block.
    useEffect(function () {
        var _a;
        if (requestFormId && spaceForMeetingServiceData) {
            var serviceDetails = spaceForMeetingServiceData === null || spaceForMeetingServiceData === void 0 ? void 0 : spaceForMeetingServiceData.getSpacesByIds[0];
            var completedRequest = (_a = serviceDetails === null || serviceDetails === void 0 ? void 0 : serviceDetails.meetingServiceRequests) === null || _a === void 0 ? void 0 : _a.find(function (request) { return request.meetingService.id === requestFormId; });
            setSpaceRequestFormCompletion(completedRequest ? 'complete' : 'incomplete');
        }
    }, [
        requestFormId,
        spaceForMeetingServiceData,
        setSpaceRequestFormCompletion,
    ]);
    // Reset on unmount (space removed or swapped) so a stale verdict from this
    // space can't block or unblock validation for the next one.
    useEffect(function () {
        return function () { return setSpaceRequestFormCompletion('unknown'); };
    }, [setSpaceRequestFormCompletion]);
    var showMeetingBuffers = checkFlag('hydra(meeting-buffers)') &&
        !featureFlagsLoading &&
        !isAllDayEvent &&
        !recurrenceRule;
    useEffect(function () {
        if (isAllDayEvent || recurrenceRule) {
            setValue('spaceBuffers', undefined);
        }
    }, [isAllDayEvent, setValue, recurrenceRule]);
    return (_jsx(SpaceDetailsContext.Provider, { value: {
            requestOnlySpace: requestOnlySpace,
            initialEvent: initialEvent,
            eventPermissions: eventPermissions,
            onTrackBufferEvent: onTrackBufferEvent,
            showMeetingBuffers: showMeetingBuffers,
            loading: featureFlagsLoading,
            workplaceServiceRequestFormStatus: workplaceServiceRequestFormStatus,
            setWorkplaceServiceRequestFormStatus: setWorkplaceServiceRequestFormStatus,
            /* Workplace Service Request */
            spaceForMeetingServiceData: spaceForMeetingServiceData,
            spaceForMeetingServiceLoading: spaceForMeetingServiceLoading,
            spaceForMeetingServiceError: spaceForMeetingServiceError,
            refetchSpaceForMeetingService: refetchSpaceForMeetingService,
            handleGetSpaceForMeetingService: handleGetSpaceForMeetingService,
            handleWorkplaceServiceError: handleWorkplaceServiceError,
            onSuccessfulRequest: onSuccessfulRequest,
        }, children: children }));
};
export var useSpaceDetailsContext = function () {
    return useContext(SpaceDetailsContext);
};
